import { makeComponent } from '../core';
import React from 'react';

export const ActionBar = makeComponent( class extends React.Component<{$id:string}>{
   render() {
       return this.props.children || null;
   }
});